
import { Component, Prop, Vue } from "vue-property-decorator";
import QaAnswerContent from "@/components/QA/QaAnswerContent.vue";
import QaFeedback from "@/components/QA/QaFeedback.vue";
import { MobileQaItem } from "@/models/QaAnswer";

@Component({
  components: { QaAnswerContent, QaFeedback },
})
export default class MobileAns extends Vue {
  @Prop() public back!: any;
  @Prop() public AnswerList!: MobileQaItem;

  mounted() {
    this.scrollToTop();
  }

  updated() {
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }
}
